import {GREEN, LIGHTGRAY, LIGHTRED, YELLOW, LIGHTBROWN, SALATGREEN, LIGHTYELLOW, BROWN,
 LIGHTGREEN, GRAY, VIOLET, DARKGRAY, RED, LIGHTBLUE, LIGHTLIGHTGRAY, BLUE, VIOLET2, ORANGE, CYAN200, GREY300} from '../colors';
import {TOGGLE_POP, SET_POPUP} from './actions';
import { TOGGLE_ALL as TOGGLE_ALL_IND, TOGGLE_IDUSTRY } from '../mapData/actions';
import grey from '@material-ui/core/colors/grey';
import { TOGGLE_ALL as TOGGLE_ALL_EMP_, TOGGLE_EMPLOYED_BY_NAME as TOGGLE_EMPLOYED_BY_NAME_ } from '../employedCount/actions';
import { TOGGLE_ALL_TYPE as TOGGLE_ALL_EMP_VEIDS, TOGGLE_EMPLOYED_BY_NAME as TOGGLE_EMPLOYED_BY_NAME_VEIDS } from '../employedCountVeids/actions';

const DefaultState = {
  activeInduestries: [[0, 0], [0, 1], [0, 2], [0, 3]], //examples: [ [0] - 'Lauksaimniecība', [1, 3] - Vieglā rūpniecība ]
  activePopupData: [],
  data: [
    {
      name: "Vecuma grupas", //Būvniecība
      color: LIGHTBLUE,
      active: false,
      textStyle: {color: grey[800]},
      style: {fontSize: '1em', color: grey[300], borderBottom:'1px solid ' + grey[300] },
      tooltip: true, tooltipText: 'Anonimizētu Salaspils novadā deklarēto iedzīvotāju skaits, vecuma grupas un dzīvesvietu izvietojums 2019.g.',
      childs: [
        {alias: 'iedz0_6', name: '0 - 6 gadi', color: LIGHTRED },
        {alias: 'iedz7_18', name: '7 - 18 gadi', color: ORANGE },
        {alias: 'iedz19_62', name: '19 - 62 gadi', color: LIGHTBLUE },
        {alias: 'iedz63', name: '63 gadi un vairāk', color: GRAY }
      /*  {alias: 'iedz0-1', name: '0 - 1 gadi', color: LIGHTRED },
        {alias: 'iedz2-4', name: '2 - 4 gadi', color: LIGHTRED },
        {alias: 'iedz5-6', name: '5 - 6 gadi', color: LIGHTRED },
        {alias: 'iedz7-12', name: '7 - 12 gadi', color: ORANGE },
        {alias: 'iedz13-15', name: '13 - 15 gadi', color: ORANGE },
        {alias: 'iedz16-18', name: '16 - 18 gadi', color: ORANGE },
        {alias: 'iedz19-25', name: '19 - 25 gadi', color: LIGHTBLUE },
        {alias: 'iedz26-30', name: '26 - 30 gadi', color: LIGHTBLUE },
        {alias: 'iedz31-62', name: '31 - 62 gadi', color: LIGHTBLUE },
        {alias: 'iedz63', name: '63 gadi un vairāk', color: GRAY },*/
      ]
    },
/*     {
        name: "Adreses bez deklarētajiem iedzīvotājiem",
        alias: "nondec",
        color: CYAN200,
        active: false,
        style: {fontSize: '1em', borderBottom:'1px solid ' + GREY300 },
      //  tooltip: true, tooltipText: 'NACE saimniecisko darbību klasifikācijas A sadaļa',
      }*/
    ]
  }

export const recursiveLoop = (data, cb, depth = 0) => {

  if( depth > 10 ) {
    throw new('ERROR: max recursive depth!');
  }

  for ( var i = 0, len = data.length; i < len; i++ ) {

      cb(data[i], depth, i);

      if(typeof data[i].childs === 'object') {
        recursiveLoop(data[i].childs, cb, depth++);
      }
  }
}

export  const population = (state = DefaultState, action) => {
  switch (action.type) {
    case TOGGLE_POP:

      var newstate = Object.assign({}, state);

      var indexes = action.indexes;
      if(indexes.length === 1) {

        newstate.data[indexes[0]].active = (newstate.data[indexes[0]].active ? false : true);

        if(newstate.data[indexes[0]].childs) {
          
          for (var i = newstate.data[indexes[0]].childs.length - 1; i >= 0; i--) {
            newstate.data[indexes[0]].childs[i].active = false;
          }
        }


        newstate.data[indexes[0]] = Object.assign({}, newstate.data[indexes[0]]);
      }

      if(indexes.length === 2) {

        newstate.data[indexes[0]].active = false;

        newstate.data[indexes[0]].childs[indexes[1]].active = (newstate.data[indexes[0]].childs[indexes[1]].active ? false : true);
        newstate.data[indexes[0]].childs[indexes[1]] = Object.assign({}, newstate.data[indexes[0]].childs[indexes[1]]);
      }

      return newstate;
    case SET_POPUP:

      return Object.assign({}, state, {activePopupData: action.data});
    break;
      case TOGGLE_ALL_EMP_VEIDS:
      case TOGGLE_EMPLOYED_BY_NAME_VEIDS:
      case TOGGLE_ALL_EMP_:
      case TOGGLE_EMPLOYED_BY_NAME_:
      case TOGGLE_ALL_IND:
      case TOGGLE_IDUSTRY:
      case 'schoolMenu_TOGGLE_BY_IDS_SINGLE':
      case 'students_TOGGLE_BY_IDS_SINGLE':
      case 'sportInfrastructure_TOGGLE_BY_IDS_SINGLE':

            var newstate = Object.assign({}, state);

            recursiveLoop(newstate.data, (entry)=>{
                
              entry.active = false;
                
            });

            return newstate;
        break;
        case 'mobility_ACTIVATE_BY_IDS':

            var newstate = Object.assign({}, state);

            if(action.data.indexOf("dev_center_atta") === -1) {

                
                recursiveLoop(newstate.data, (entry)=>{
                    entry.active = false;
                });
            }

            return newstate;
        break;
        case 'schoolMenu_TOGGLE_BY_IDS_SINGLE':

              var newstate = Object.assign({}, state);
              if(action.data.indexOf("middle_school_model") === -1) {
                 
                recursiveLoop(newstate.data, (entry)=>{

                  entry.active = false;

                });
              }

              

           return newstate;
        break;
    default:
      return state;
  }
}

export const getColorMap = state => {

  var colorMap = {};

  recursiveLoop(state.population.data, (category) => {

    if(category.alias) {
          colorMap[category.alias] = category.color; 
        } else {
          colorMap[category.name] = category.color; 
        }

  });

  return colorMap;
}

export const getActive = (state, full = false) => {

  const activeInd = [];
  recursiveLoop(state.population.data, (categ) => {

    if(typeof categ.active === 'boolean' && categ.active) {



      if(typeof categ.alias !== 'undefined') {

        activeInd.push(categ.alias);
      } else {

        activeInd.push(categ.name);
      }

      if(typeof categ.childs !== 'undefined') {

        for (var i = categ.childs.length - 1; i >= 0; i--) {
          activeInd.push(categ.childs[i].alias);
        }
      }
    }
  });

  return activeInd;
}






// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/population/reducer.js